import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const TOKEN_SLICE_INITIAL = {
  isRefetchTokenLoading: false
} satisfies FlowState as FlowState;

type FlowState = {
  isRefetchTokenLoading: boolean;
};

export const tokenSlice = createSlice({
  name: "token",
  initialState: TOKEN_SLICE_INITIAL,

  reducers: {
    setIsRefetchTokenLoading: (state, action: PayloadAction<boolean>) => {
      state.isRefetchTokenLoading = action.payload;
    }
  }
});

export const { setIsRefetchTokenLoading } = tokenSlice.actions;
